// @flow

import React from 'react';
import { NewsPreview } from '@starladder/ui-react';
import classNames from 'classnames';
import LazyLoad from 'react-lazyload';

import EventLink from 'event/helpers-components/EventLink';
import DateTime from 'shared/helpers-components/DateTime';

import type { NewsItemType } from 'shared/logic/news/types';

import style from './NewsPreviewRegular.module.css';

type PropsType = NewsItemType;

function NewsPreviewRegular({
  slug,
  title,
  description,
  img,
  imgMaxWidth,
  isVideo,
  isLoading,
  publishedAt,
  styleMod,
  locale
}: PropsType) {
  const newsPreview = (
    <LazyLoad height={500}>
      <NewsPreview
        img={img}
        imgMaxWidth={imgMaxWidth}
        isLoading={isLoading}
        title={title}
        isVideo={isVideo}
        videoIcon="video"
        publishedAt={<DateTime dateTime={publishedAt} format="date_short_1" />}
        hasImg={!img || !img.medium ? false : img.medium.indexOf('assets/fallback/article/picture-') === -1}
        hasDescription
        description={description}
        style={style}
      />
    </LazyLoad>
  );

  if (slug) {
    const href = `/news/[articleSlug]?articleSlug=${slug[locale]}`;
    const as = `/news/${slug[locale]}`;

    return (
      <EventLink href={href} as={as} noQueryInUrl>
        <a className={classNames(style.newsPreviewHolder, style[`mod-${styleMod}`])}>{newsPreview}</a>
      </EventLink>
    );
  }

  return newsPreview;
}

export default NewsPreviewRegular;
